import { usePerformanceAudienceFormatters } from '../../hooks/usePerformanceAudienceFormatters';
import { PerformanceAudienceSummary } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { LuStar } from 'react-icons/lu';
import { twMerge } from 'tailwind-merge';

const DATE_RANGE_DAYS: Record<string, number> = {
  last_7_days: 7,
  last_14_days: 14,
  last_30_days: 30,
};

type PerformanceAudienceScopeBannerProps = {
  summary: PerformanceAudienceSummary;
  dateRange: string;
  onEditScope?: () => void;
};

export const PerformanceAudienceScopeBanner: FC<PerformanceAudienceScopeBannerProps> = ({ summary, dateRange, onEditScope }) => {
  const { t } = useTranslation('performanceAudience');
  const { formatNumber } = usePerformanceAudienceFormatters();
  const days = DATE_RANGE_DAYS[dateRange] ?? 7;

  return (
    <section
      className={twMerge(
        'flex flex-col gap-3 rounded-lg border border-primary-border bg-primary-background p-4',
        'sm:flex-row sm:items-center sm:justify-between'
      )}
    >
      <div className='flex items-start gap-3'>
        <span className='grid size-8 shrink-0 place-items-center rounded-full bg-white text-brand-600 shadow-sm'>
          <LuStar className='size-4' aria-hidden />
        </span>
        <p className='text-sm text-primary-800'>
          <Trans
            i18nKey='performanceAudience:banner.description'
            values={{
              audienceName: summary.audienceName,
              userCount: formatNumber(summary.audienceUserCount),
              googleCampaigns: summary.googleCampaignCount,
              metaAdSets: summary.metaAdSetCount,
              days,
            }}
            components={{ strong: <strong className='font-semibold text-primary-900' /> }}
          />
        </p>
      </div>
      <button
        type='button'
        onClick={onEditScope}
        className='shrink-0 self-start text-sm font-semibold text-brand-700 hover:text-brand-800 sm:self-center'
      >
        {t('banner.editScope')}
      </button>
    </section>
  );
};
